import React, { useState } from 'react';

export default function ConfirmModal({ title, message, confirmText = 'Confirm', cancelText = 'Cancel', confirmStyle = 'danger', requireType, onConfirm, onCancel }) {
  const [typed, setTyped] = useState('');
  const needsTyping = !!requireType;
  const typingMatch = needsTyping && typed.toLowerCase() === requireType.toLowerCase();

  const buttonStyles = {
    danger: 'bg-red-600 hover:bg-red-700 text-white',
    primary: 'bg-brand-600 hover:bg-brand-700 text-white',
    warning: 'bg-amber-600 hover:bg-amber-700 text-white',
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60]">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 whitespace-pre-line">{message}</p>
        {needsTyping && (
          <div className="mb-4">
            <label className="block text-sm text-gray-600 dark:text-gray-400 mb-1">
              Type <span className="font-mono font-bold text-red-600 dark:text-red-400">{requireType}</span> to confirm:
            </label>
            <input
              type="text"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              className="block w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 shadow-sm text-sm px-3 py-2 focus:ring-red-500 focus:border-red-500"
              autoFocus
            />
          </div>
        )}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={needsTyping && !typingMatch}
            className={`px-4 py-2 text-sm font-medium rounded-md disabled:opacity-40 disabled:cursor-not-allowed ${buttonStyles[confirmStyle] || buttonStyles.danger}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
